import translate from "./../../lib/translate/TranslateJs";
import { getFEWalletParams } from "./../../../platform.pay.config";
import { formatNumber } from "../utils";
import { insufficientToWithdrawModal } from '../../Components/Common/Modals';

// infor 一个按钮
//confirm 两个按钮
const withdrawKyc = () => {
    let translates = translate
    const { goFinishKYCInfo, LivechatClick } = getFEWalletParams() || {}
    return {
        'SNC0001': {
            title: translates("实名验证")(),
            children: translates("我们注意到您的帐户有异常情况。 请在“上传个人文件”部分上传必要的文件以验证您的身份，或联系在线聊天寻求支持。")(),
            noBtnTxt: translates("稍后验证")(),
            noFunction: () => {

            },
            okBtnTxt: translates("立即验证")(),
            okFunction: () => {
                goFinishKYCInfo()
            }
        },
        'SNC0002': {
            title: translates("等待验证")(),
            children: translates("系统检测到您验证的真实姓名与提款银行账户持有人姓名不符。 请在个人资料/上传文件中上传必要的文件以验证您的身份。如果您已更新，请等待我们处理您的验证。 如果您需要更多信息，请联系在线聊天")(),
            noBtnTxt: translates("我已上传")(),
            noFunction: () => {

            },
            okBtnTxt: translates("立即验证")(),
            okFunction: () => {
                goFinishKYCInfo()
            }
        },
        'SNC0003': {
            title: translates("提现交易临时")(),
            children: translates("系统检测到您验证的真实姓名与提款银行账户持有人姓名不符。 请在个人资料/上传文件中上传必要的文件以验证您的身份。如果您已更新，请等待我们处理您的验证。 如果您需要更多信息，请联系在线聊天")(),
            // children: translates("由于您的新银行账户正在接受身份验证，因此您的提款请求目前不可用。 请稍后回来或联系在线聊天以获取更多信息")(),
            okBtnTxt: translates("知道了")(),
            okFunction: () => {

            },
            noBtnTxt: translates("在线聊天")(),
            noFunction: () => {
                LivechatClick()
            }
        },
        'P106003': {//您的提款请求已提交。 但是您已达到最大提款限额。 请在个人资料 -“上传文件页面”上传所需文件以验证您的身份
            title: translates("实名验证")(),
            children: translates("您的提款请求已提交。 但是您已达到最大提款限额。 请在个人资料 -“上传文件页面”上传所需文件以验证您的身份")(),
            noBtnTxt: translates("稍后验证")(),
            noFunction: () => {

            },
            okBtnTxt: translates("立即验证")(),
            okFunction: () => {
                goFinishKYCInfo()
            }
        },
        'P106004': {//我们注意到您帐户存在异常。 请在个人资料-“上传文件页面”上传所需文件以验证您的身份，或联系在线客服寻求协助。
            title: translates("实名验证")(),
            children: translates("我们注意到您帐户存在异常。 请在个人资料-“上传文件页面”上传所需文件以验证您的身份，或联系在线客服寻求协助。")(),
            noBtnTxt: translates("稍后验证")(),
            noFunction: () => {

            },
            okBtnTxt: translates("立即验证")(),
            okFunction: () => {
                goFinishKYCInfo()
            }
        },
        'P106005': {//您的提款请求已提交。 但是系统检测到您的注册名字与提款银行帐户名称之间存在差异。 请在个人资料 -“上传文件页面”上传所需文件以验证您的身份，或联系在线客服寻求协助。
            title: translates("实名验证")(),
            children: translates("系统检测到您验证的真实姓名与提款银行账户持有人姓名不符。 请在个人资料/上传文件中上传必要的文件以验证您的身份。如果您已更新，请等待我们处理您的验证。 如果您需要更多信息，请联系在线聊天")(),
            noBtnTxt: translates("稍后验证")(),
            noFunction: () => {

            },
            okBtnTxt: translates("立即验证")(),
            okFunction: () => {
                goFinishKYCInfo()
            }
        }
    }
}



export function withdrawModalHandle({ res, PendingWithdraw, WithdrawKycModal, InsertNewAccountHolderName, accountHolderName, firstName, methods }) {
    let { modalTip, toastTip } = getFEWalletParams()
    let { result, errors } = res
    let { warnings = '' } = result || {}
    let code = warnings[0]?.code
    let message = warnings[0]?.message || ''


    if (!code) {
        message = errors[0]?.message || ''
        code = errors[0]?.errorCode
    }

    let codeArr = ['SNC0001', 'SNC0002', 'SNC0003']
    let codeArr2 = ['P106003', 'P106004', 'P106005']
    if (codeArr.includes(code)) {
        let { title, children, noBtnTxt, okBtnTxt, noFunction, okFunction } = withdrawKyc()[code]
        if (code == 'SNC0001') {
            //添加提款银行姓名
            InsertNewAccountHolderName && InsertNewAccountHolderName()
        }
        modalTip.confirm({
            title,
            children: WithdrawKycModal({ children, code, accountHolderName, firstName }),
            noBtnTxt,
            noFunction: () => {
                noFunction()
            },
            okBtnTxt,
            okFunction: () => {
                okFunction()
            }
        })
    } else if (codeArr2.includes(code)) {
        let { title, children, noBtnTxt, okBtnTxt, noFunction, okFunction } = withdrawKyc()[code]
        modalTip.confirm({
            title,
            children: WithdrawKycModal({ children, code, accountHolderName, firstName }),
            noBtnTxt,
            noFunction: () => {
                noFunction()
            },
            okBtnTxt,
            okFunction: () => {
                okFunction()
            }
        })
    } else if (code === "VAL11012"){
        insufficientToWithdrawModal();
    } else if (code == 'P101018') {
        modalTip.confirm({
            title: translate("温馨提示")(),
            children: this.props.ThresholdWithdraw(),
            okBtnTxt: translate("账户变更")(),
            okFunction: () => { },
            noBtnTxt: translate("继续")(),
            noFunction: () => {

            }
        })
    } else if (code == 'P101103') {
        let { lastWithdrawalID = '', lastWithdrawalAmount = '' } = result
        let tempObj = [
            {
                key: translate("提款编号：")(),
                value: lastWithdrawalID
            },
            {
                key: translate("提款金额：")(),
                value: translate("￥ <#0#>")(formatNumber(lastWithdrawalAmount))
            },
        ]
        modalTip.info({
            wrapClassName:"pendingModal",
            title: translate("重要提示")(),
            children: PendingWithdraw(tempObj),
            okBtnTxt: translate("同意")(),
            onlyOKBtn:true,
            leftBody: true,
            type:"info",
        })


        getFEWalletParams().appPiwikEvent({
            path: `withdrawal_${methods.toLocaleLowerCase()}_submit_popup`,
            title: `Withdrawal ${methods} Reminder Double Submit`
        })
    } else {
        let message = res?.errors[0]?.description || res?.errors[0]?.message
        toastTip.error(message)
    }
}
